var TRACKINGDATA = {
  changeZip: {
    'Event Metadata': {
      action_type: 'link',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:results:zip submit',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
      {
        key_name: 'action_category',
        parent: 'Event Metadata',
        search: '[page_name] results',
        type: 'dynamicName',
      },
    ],
    Dealer: {
      dealer_locator_search_type: 'zip',
      dealer_locator_search_term: '',
    },
  },
};

module.exports = TRACKINGDATA;
